export const useActTargets = createQuery('/act_classrooms/:act_classroom_id/targets', {nullCollection: {}, nullRecord: {}})
